import type { BackMode, H5ToRNMessage, MediaWay } from './types'

/** 向 React Native WebView 发送消息（超过两个地方使用相同的参数则需要提取为单独的函数） */
export function postMessageToRN(data: H5ToRNMessage): void {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(data))
  }
}

/** 通知 RN 返回上一页 */
export function goBackToRN(): void {
  postMessageToRN({ type: 'goBack' })
}

/** 通知 RN 跳转原生路由 */
export function goJumpToRN(route: string, data: any = {}): void {
  postMessageToRN({ type: 'navigate', params: { route, args: data } })
}

/** 通知 RN 重置路由 */
export function goResetToRN(route = ''): void {
  postMessageToRN({ type: 'reset', params: { route } })
}

/** 通知 RN 打开地图导航 */
export function openMapToRN(mapType: string, lng: number, lat: number, poi: string): void {
  postMessageToRN({ type: 'openMap', params: { mapType, lng, lat, poi } })
}

/** 通知 RN 用 AgreeWebView 打开协议页面 */
export function openProtocolToRN(title: string, path: string): void {
  const baseUrl = import.meta.env.VITE_PROTOCOL_DOMAIN
  const url = `${baseUrl}/${path}`
  postMessageToRN({ type: 'navigate', params: { route: 'AgreeWebView', args: { title, url } } })
}

/** 通知 RN 持久化键值数据（如 userInfo） */
export function saveDataToRN(key: string, data: unknown): void {
  postMessageToRN({ type: 'saveData', params: { key, data } })
}

/** 通知 RN 登出 */
export function logoutToRN(): void {
  postMessageToRN({ type: 'logout' })
}

/** 通知 RN 打开外部 URL */
export function openURLToRN(url: string): void {
  postMessageToRN({ type: 'openURL', params: { url } })
}

/** 通知 RN 打开系统媒体库（camera=拍照，album=相册） */
export function openMediaLibrary(way: MediaWay): void {
  postMessageToRN({ type: 'media-library', params: { way } })
}

/**
 * 返回手势上报：仅在 backMode 变化时调用
 * @param mode allow | block | exit
 * @param path 当前路由路径，供 RN 校验/打点/识别过期消息
 */
export function reportBackMode(mode: BackMode, path: string): void {
  postMessageToRN({ type: 'setBackEnabled', params: { mode, path } })
}

/** 通知 RN 开始录音（请求权限并启动） */
export function startRecordToRN(): void {
  postMessageToRN({ type: 'record', params: { action: 'start' } })
}

/** 通知 RN 停止录音并回传 base64 */
export function stopRecordToRN(): void {
  postMessageToRN({ type: 'record', params: { action: 'stop' } })
}

/** 通知 RN 取消录音（停止并丢弃） */
export function cancelRecordToRN(): void {
  postMessageToRN({ type: 'record', params: { action: 'cancel' } })
}

/** 请求 RN 原生下载对方语音（绕开 WKWebView CORS）；结果经 downloadAudioResult 按 messageId 回传 */
export function downloadAudioToRN(messageId: string, audioUrl: string): void {
  postMessageToRN({ type: 'downloadAudio', params: { messageId, audioUrl } })
}

/** 调试日志桥接到 RN（Xcode 控制台可见），排查 WKWebView 内不可见的 H5 日志 */
export function logToRN(msg: string): void {
  postMessageToRN({ type: 'log', params: { msg } })
}

/** 通知 RN 压入新 WebView 加载 H5 路径（原页留栈,返回回原页;对齐 RN pushWebView） */
export function pushWebViewToRN(urlPath: string): void {
  postMessageToRN({ type: 'pushWebView', params: { urlPath } })
}
